'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _components = require('components');

var _reactI18next = require('react-i18next');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./EmailWysiwyg.scss');

var quillModules = {
  toolbar: {
    container: [[{ font: [] }], [{ size: ['small', false, 'large', 'huge'] }], [{ align: [] }], ['bold', 'italic', 'strike', 'underline'], [{ color: [] }, { background: [] }], [{ list: 'ordered' }, { list: 'bullet' }], ['link']],
    handlers: {}
  }
};
var quillFormats = ['font', 'size', 'align', 'bold', 'italic', 'strike', 'underline', 'color', 'background', 'list', 'bullet', 'link'];

var EmailWysiwyg = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    showEmailWysiwyg: state.project.showEmailWysiwyg,
    saveEmailLoading: state.project.saveEmailLoading,
    testEmailLoading: state.project.testEmailLoading,
    project: state.project.projectData
  };
}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(EmailWysiwyg, _Component);

  function EmailWysiwyg() {
    var _ref;

    (0, _classCallCheck3.default)(this, EmailWysiwyg);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmailWysiwyg.__proto__ || (0, _getPrototypeOf2.default)(EmailWysiwyg)).call.apply(_ref, [this].concat(args)));

    _this.state = { saveAsTemplate: false };
    if (typeof window !== 'undefined') {
      // see https://github.com/zenoamaro/react-quill/issues/122
      _this.ReactQuill = require('react-quill');
    }
    return _this;
  }

  (0, _createClass3.default)(EmailWysiwyg, [{
    key: 'saveEmail',
    value: function saveEmail() {
      var _props = this.props,
          projectId = _props.projectId,
          saveEmail = _props.saveEmail;
      var saveAsTemplate = this.state.saveAsTemplate;

      var subject = this.emailSubjectEl.value;
      var content = this.emailMessageEl.getEditorContents();
      saveEmail(projectId, { content: content, subject: subject, saveAsTemplate: saveAsTemplate });
    }
  }, {
    key: 'testEmail',
    value: function testEmail() {
      var _props2 = this.props,
          projectId = _props2.projectId,
          testEmail = _props2.testEmail,
          t = _props2.t;

      testEmail(projectId).promise.then(function () {
        return _toastr2.default.success(t('A sampler email was sent to your personal email account.'));
      });
    }

    /* eslint-disable react/no-danger */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ReactQuill = this.ReactQuill;
      var _props3 = this.props,
          t = _props3.t,
          toggleEmailWysiwyg = _props3.toggleEmailWysiwyg,
          project = _props3.project,
          showEmailWysiwyg = _props3.showEmailWysiwyg,
          saveEmailLoading = _props3.saveEmailLoading,
          testEmailLoading = _props3.testEmailLoading;
      var saveAsTemplate = this.state.saveAsTemplate;


      if (!project) {
        return null;
      }

      return showEmailWysiwyg ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('input', {
          type: 'text',
          className: 'width-perc-100',
          placeholder: t('Subject'),
          defaultValue: project.subject,
          ref: function ref(el) {
            return _this2.emailSubjectEl = el;
          }
        }),
        ReactQuill && _react2.default.createElement(ReactQuill, {
          theme: 'snow',
          modules: quillModules,
          formats: quillFormats,
          defaultValue: project.content,
          ref: function ref(el) {
            return _this2.emailMessageEl = el;
          }
        }),
        _react2.default.createElement(_components.Checkbox, {
          name: 'saveAsTemplate',
          checked: saveAsTemplate,
          onChange: function onChange(e) {
            return _this2.setState({ saveAsTemplate: e.target.checked });
          },
          textAfter: t('Save this email as template for future use')
        }),
        ';',
        _react2.default.createElement(
          'div',
          { className: 'hint small' },
          t('INFO. The <Name> and <Surname> tags will pull in each recipients names to personalise the email.')
        ),
        _react2.default.createElement(
          'div',
          { className: 'text-right margin-top-10' },
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-default wide', onClick: toggleEmailWysiwyg },
            t('Cancel')
          ),
          saveEmailLoading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary wide margin-left-20', onClick: function onClick() {
                return _this2.saveEmail();
              } },
            t('Save')
          )
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          t('Subject'),
          ': ',
          project.subject
        ),
        _react2.default.createElement('div', { className: (0, _classnames2.default)('ql-editor', styles.preview), dangerouslySetInnerHTML: { __html: project.content } }),
        _react2.default.createElement(
          'div',
          { className: 'text-right margin-top-10' },
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-default wide', onClick: toggleEmailWysiwyg },
            t('Edit')
          ),
          testEmailLoading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-default wide margin-left-20', onClick: this.testEmail },
            t('Test')
          )
        )
      );
    }
    /* eslint-enable react/no-danger */

  }]);
  return EmailWysiwyg;
}(_react.Component), _class3.propTypes = {
  project: _propTypes2.default.object,
  projectId: _propTypes2.default.number,
  saveEmail: _propTypes2.default.func,
  saveEmailLoading: _propTypes2.default.bool,
  showEmailWysiwyg: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  testEmail: _propTypes2.default.func,
  testEmailLoading: _propTypes2.default.bool,
  toggleEmailWysiwyg: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'testEmail', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'testEmail'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = EmailWysiwyg;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/EmailWysiwyg.js
// module id = 2085
// module chunks = 1